export default __webpack_public_path__ + "f6764186bd7b9bed2da54ede8ee7c4f6.png";